export const setLocalStorage = (key, value) => {
  localStorage[key] = value
}
export function getLocalStorageToken() {
  return localStorage['token']
}
export function removeLocalStorageToken() {
  localStorage.removeItem('token')
}
